<template>
    <div class="border_config chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">宽度</span>
            <el-input v-model="config.width" @change="getRender" type="number"></el-input>
            <div class="unit">px</div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'border_config',
        components: {},
        data() {
            return {}
        },
        computed: {
            config() {
                return this.$store.state.designer.chart.setting.params;
            },
        },
        methods: {
            getRender() {
                this.$store.dispatch('screenRender');
            },
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .border_config {

    }
</style>